import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {StudentAuthGuard} from './@core/student-auth.guard';
import {SignInComponent} from './pages/sign-in/sign-in.component';
import {LayoutComponent} from './pages/layout/layout.component';
import {MenuPageComponent} from './pages/menu-page/menu-page.component';
import {UnauthorizedComponent} from './pages/unauthorized/unauthorized.component';
import {ImpersonateComponent} from './pages/sign-in/impersonate.component';
import {LavatoryOccupancyComponent} from './modules/utility-status/lavatory-occupancy.component';


const routes: Routes = [
  {path: 'unauthorized', component: UnauthorizedComponent},
  {path: 'impersonate', component: ImpersonateComponent},
  {path: 'iot-helper', component: LavatoryOccupancyComponent},
  {
    path: 'login', component: LayoutComponent, children: [
      {path: '', component: SignInComponent},
      {path: ':token', component: SignInComponent},
      {path: ':redirect/:token', component: SignInComponent},
    ]
  },
  {
    path: '', component: LayoutComponent, canActivate: [StudentAuthGuard], children: [
      {path: '', redirectTo: 'menu', pathMatch: 'full'},
      {path: 'menu', component: MenuPageComponent},
      {path: 'resident', loadChildren: () => import('./modules/resident/resident.module').then(m => m.ResidentModule)},
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {enableTracing: false})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
